/* eslint-disable max-len */
import { Component } from '@angular/core';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { BaseDataResponse, BaseState, LoginParams } from '@base/entities/BaseEntities';
import { LoginService } from '@core/framework/login.service';
import { EnumLoginSecureKeyTypes } from '@core/framework/sysenums.enum';
import { VersionDescriptor } from '@m4u-angular/configuration/app.config.service';
import { LoginEndpoint } from '@m4u-angular/core/endpoints/login.endpoint';

class State extends BaseState {
    ReturnUrl: string;
    Stage: number;
    ModulesVersion: VersionDescriptor[] = [];
}

@Component({
    providers: ServiceBagServices,
    selector: 'm4u-login-oauth',
    templateUrl: './login-oauth.component.html',
    styleUrls: ['./login-oauth.component.scss']
})
export class LoginOAuthComponent extends BasePageComponent<LoginParams, State> {
    
    
    constructor(A: ServiceBagService,
        private loginService: LoginService,
        private loginEndpoint: LoginEndpoint) {
        super(A, 'LoginComponent', LoginParams, State);
    }

    override OnInitComponent() {
        this.A.AppConfigService.AppConfig.OnLoginPage();

        //Support for return URL
        this.State.ReturnUrl = this.A.Navigator.FixDeploymentLocation(this.State.ReturnUrl);

        
        //Coming back from redirect. Manually decode, since double encoding is used for state
        if (this.QueryParams.code != undefined && this.QueryParams.iss != undefined) {
            this.State.Stage = 2;
            this.Entity.UserName ='oAuth';
            this.Entity.SecureKeyType = EnumLoginSecureKeyTypes.OAuth;
            this.Entity.SecureKey = this.QueryParams.code;
            this.State.ReturnUrl = decodeURIComponent(this.QueryParams.state);
            console.log(`Came from redirect with:${this.State.ReturnUrl}`);
            this.OnDoLogin();
        } else {
            this.State.Stage = 1;
            this.OnRedirectToAuthority();
        }

    }




    //Perform the login
    OnDoLogin() {
        this.loginService.DoLogin(this.Entity, false, false, () => {
            this.OnAfterLogin();
        }, null, null)
            .subscribe(() => { });
    }

    OnAfterLogin() {
        if (this.State.ReturnUrl) {
            this.A.Navigator.NavigateByUrl(this.State.ReturnUrl);
        } else {
            this.A.Framework.NavigateDefault();
        }
    }



    OnRedirectToAuthority() {
        console.log(`Initiating redirect with:${this.State.ReturnUrl}`);
        this.Do(this.loginEndpoint.GetOAuthRedirectURL(this.State.ReturnUrl), false, (response: BaseDataResponse<string>) => {
            if (response.IsSuccess) {
                console.log(`Redirecting to:${response.Data}`);
                this.A.Navigator.NavigateExternal(response.Data, false);
            } else {
                this.UI.StopMessage(response.ResponseMessage);
            }
        });
    }
}
